import React, { Component } from 'react';
import '../../../styles/global.scss';
import UnitChart from "./unit-chart";
import {HorizontalBar} from "react-chartjs-2";
import {from} from "linq"
import {createBarDataSetFrom} from "../../../helpers/chart-dataset-helpers";
import {UtilityColors} from "../constants/chart-color-constants";
import * as moment from "moment";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom'; // Import withRouter HOC for programmatic navigation
/**
 *
 */
class SiteRankedChart extends Component {
    constructor(props) {
        super(props);

        this.rankingData = this.generateRankingData();
        this.minimumValue = this.calculateMinimumValue();
        this.utilitiesToUse = this.props.utilitiesToUse || ["Gas", "Electricity", "Water"];

        this.state = {
            labels: this.generateLabels(),
            datasets: this.generateConsumptionDataset(),
            options: this.generateConsumptionOptions()
        };
    }

    get shouldOrderAscending() {
        return (this.props.order || "").toLowerCase().indexOf("asc") >= 0;
    }

    getSiteNameFor(siteKey) {
        var siteLookup = this.props.siteLookups.find(x => x.key === siteKey);

        try //undefined check refused to work...
        {
            return siteLookup.name.toString().substr(0, 30);//truncate
        }catch(err)
        {
            return siteKey
        }
    }

    calculateMinimumValue() {
        return this.rankingData.length > 0 ? from(this.rankingData).last().total : 0;
    }

    generateRankingData() {
  


        const recentCutoffDate = moment().startOf('month');
        const oldestCutoffDate = moment().startOf('month').subtract(this.props.months || 12, "months");

        let enumerableData = from(this.props.data)
           .where(x => {
                const date = moment(x.fldMonth);
                return (date >= oldestCutoffDate && date < recentCutoffDate);
            })
            .groupBy(x => x.siteKey, null,(key, group) => {
                return {
                    site: { key, name: this.getSiteNameFor(key) },
                    total: group.sum(x => x[this.props.comparisonField]),
                    breakdown: {
                        gas: group.where(x => x.utility === "Gas").sum(x => x[this.props.comparisonField]).toFixed(2),
                        electricity: group.where(x => x.utility === "Electricity").sum(x => x[this.props.comparisonField]).toFixed(2),
                        water: group.where(x => x.utility === "Water").sum(x => x[this.props.comparisonField]).toFixed(2)
                    }
                }
            });

        enumerableData = this.shouldOrderAscending ?
            enumerableData.orderBy(x => x.total) :
            enumerableData.orderByDescending(x => x.total);

        return enumerableData
            .take(this.props.count || 10)
            .toArray();
    }

    generateLabels = () => {
        return this.rankingData.map(x => x.site.name);
    };

    generateConsumptionDataset() {
        const datasets = [];

        this.utilitiesToUse.forEach(utility => {
            const dataset = createBarDataSetFrom(this.rankingData, x => x.breakdown[utility.toLowerCase()], utility, UtilityColors[utility.toLowerCase()]);
            datasets.push(dataset);
        });

        return datasets;
    }

    generateConsumptionOptions() {


       

        return {
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        scaleLabel: {
                            display: true,
                            labelString: this.props.label || 'Total Cost (£)',
                            fontStyle: "bold"
                        },
                        ticks: {
                            
                            min: this.minimumValue > 0 ? 0 : this.minimumValue
                        }
                    }
                    ],
                yAxes: [
                    {
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        }
                    },
                ]
            },
            legend: {
                position: 'bottom'
            },
            title: {
                text: `${this.props.title || "Sites Ranking Chart"} (last ${this.props.months > 1 ? `${this.props.months} ` : ""}month${(this.props.months > 1) ? "s" : ""})`,
                display: true,
                fontSize: 13
            },
            onClick: (evt, element) => {

                
                if (element.length > 0) {

                    const firstPoint = element[0]._chart.getElementAtEvent(evt)[0];

               
                    const datasetIndex = firstPoint._datasetIndex;
                    const index = firstPoint._index;



                    const siteKey = this.rankingData[index].site.key;


                    const utilityType = this.utilitiesToUse[datasetIndex]; // Gas, Electricity, Water
            
                    // You can use utilityType to navigate to a specific URL or perform any other logic

                    const queryParams = new URLSearchParams({
                        siteKey : siteKey,
                        utility: utilityType.toLowerCase(),
                        tab : "supplier-invoices"
                      }).toString();
                      const url = `/site?${queryParams}`;


                      setTimeout(() => {

                        this.props.history.push(url);
                        },10 * 60)
                    // Log siteKey to console (Replace this with your navigation logic)
                    //this.props.history.push(`/site?siteKey=${siteKey}&tab=supplier-invoices`);//console.log(`Navigate to site with key: ${siteKey}`);
                    // Example: this.props.history.push(`/site?siteKey=${siteKey}`);
                    // Or use a callback provided via props to handle navigation
                    // this.props.onSiteClick(siteKey);
                }
            },
            
        };
    }

    render() {

        const afterEventPlugin = {
            afterEvent: (chart, args) => {
                

             

                if (args.type === 'click') { // Check if the event is a click
                    
                    const { x, y } = args;
                    if (
                        x < chart.chartArea.left &&
                        y > chart.chartArea.top &&
                        y < chart.chartArea.bottom
                    ) {
                        const labelId = chart.scales['y-axis-0'].getValueForPixel(y);


                        const siteKey = this.rankingData[labelId].site.key;


                             // You can use utilityType to navigate to a specific URL or perform any other logic

                    const queryParams = new URLSearchParams({
                        siteKey : siteKey,
                        tab : "supplier-invoices"
                      }).toString();
                      const url = `/site?${queryParams}`;


                      setTimeout(() => {

                        this.props.history.push(url);
                        },10 * 60)

                    }
                }
            }
        };

        

        return (
            <UnitChart className={"site-ranked-chart"} datasets={this.state.datasets} labels={this.state.labels} options={this.state.options}             plugins={[afterEventPlugin]}  chartType={HorizontalBar}/>
        )
    }
}

SiteRankedChart.propTypes = {
    data: PropTypes.array.isRequired,
    utilitiesToUse: PropTypes.arrayOf(PropTypes.string),
    siteLookups: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    order: PropTypes.string,
    months: PropTypes.number,
    comparisonField: PropTypes.string.isRequired,
    count: PropTypes.number,
    title: PropTypes.string,
    label: PropTypes.string
};

export default withRouter(SiteRankedChart);